import React, { Component } from 'react';
import { ListGroupItem, CustomInput, Collapse, Tooltip } from 'reactstrap';

import InputRange from 'react-input-range';




function range(begin, end, interval = 1){
  let array = [];
  for (let i = begin; i <= end; i += interval) {
    array.push(i);
  }
  return array;
}



class WaveBar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      tooltipOpen: false
    };
  }

  toggle = () => {
    this.setState({
      tooltipOpen: !this.state.tooltipOpen
    });
  }

  render() {
    const tooltipValue = this.props.filteredAbs + (this.props.abs !== this.props.filteredAbs && ' ('+this.props.abs+')')
    return (
      <div style={{ display:'flex', flex: 1, alignItems: 'flex-end', height: '100%', position: 'relative' }} href="#" id={ 'tooltip-'+this.props.label }>
        <span style={{ display:'block', width: '100%', minWidth: 1, maxWidth: 4 , height: (this.props.height+'%'), transform: 'translateX(-50%)', position: 'absolute', bottom:0, left:'50%' }} className={ (this.state.tooltipOpen ? "bg-dark" : "bg-mid-dark-gray") + " rounded-top"}></span>
        <span style={{ display:'block', width: '100%', minWidth: 1, maxWidth: 4 , height: (this.props.filteredHeight+'%'), transform: 'translateX(-50%)', position: 'absolute', bottom:0, left:'50%' }} className={ (this.state.tooltipOpen ? "bg-secondary" : "bg-white") + " rounded-top"}></span>
        { this.props.height > 0 &&
          <Tooltip placement="top" delay={{ show: 0, hide: 0 }} isOpen={this.state.tooltipOpen} target={ 'tooltip-'+this.props.label } toggle={this.toggle}>
            { this.props.tooltipString ? this.props.tooltipString.split('%label').join(this.props.label).split('%value').join(tooltipValue) : this.props.label }
          </Tooltip>
        }
      </div>
    );
  }
}



class Checkbox extends Component {
  render(){
    return (
      <React.Fragment>
        <CustomInput
          type="checkbox"
          label={ this.props.name }
          id={ this.props.name }
          checked={ this.props.checked }
          onChange={ this.props.handleChange }
          className="text-truncate paul-filter-checkbox"
        />
      </React.Fragment>
    );
  }
}

class ClusterWave extends Component {
  prepare = () => {
    const maxNumResults = Math.max(...Object.values(this.props.items)); // ie. 36 (results)
    const minValue = Math.min(...Object.keys(this.props.items)); // ie. 2001 (year)
    const maxValue = Math.max(...Object.keys(this.props.items)); // ie. 2018 (year)

    let cluster = [];
    for(var i of range(minValue, maxValue)){
      cluster.push({
        percentFull: (this.props.items.hasOwnProperty(i) ? (this.props.items[i] / maxNumResults * 100) : 0),
        absFull: (this.props.items.hasOwnProperty(i) ? this.props.items[i] : 0),
        percentFiltered: ((this.props.filteredItems && this.props.filteredItems.hasOwnProperty(i)) ? (this.props.filteredItems[i] / maxNumResults * 100) : 0),
        absFiltered: ((this.props.filteredItems && this.props.filteredItems.hasOwnProperty(i)) ? this.props.filteredItems[i] : 0),
        label: i
      });
    }
    return cluster;
  }
  render(){
    if(this.props.items){
      const values = this.prepare();
      return (
        <div style={{ position:'relative', height: 30, display: 'flex', alignItems: 'flex-end', marginBottom: -4, marginLeft: 8, marginRight: 8 }}>
          {values.map(value =>
            <WaveBar
              key={value.label}
              height={value.percentFull}
              filteredHeight={value.percentFiltered}
              abs={value.absFull}
              filteredAbs={value.absFiltered}
              label={value.label}
              tooltipString={this.props.tooltipString || false}
            />
          )}
        </div>
      );
    } else {
      return <React.Fragment></React.Fragment>
    }
  }
}


export class CheckFilter extends Component {
  constructor(props){
    super(props);
    this.state = {
      collapse: (this.props.isOpen || false),
      checkedItems: [],
    }
  }
  toggleItem = (e) => {
    const item = e.target.id;
    if(this.state.checkedItems.includes(item)){
      this.setState({
        checkedItems: this.state.checkedItems.filter(e => e !== item)
      }, () => {
        this.props.handleChange(this.state.checkedItems, this.props.field);
      })
    } else {
      this.setState({
        checkedItems: [...this.state.checkedItems, item]
      }, () => {
        this.props.handleChange(this.state.checkedItems, this.props.field);
      })
    }
  }
  toggleGroup = (e) => {
    const group = e.target.id;
    const items = this.props.groupBy[group];
    let selected_items = items.filter(item => this.state.checkedItems.includes(item))
    if (selected_items.length > 0){
      this.setState({
        checkedItems: this.state.checkedItems.filter(val => !selected_items.includes(val))
      }, () => {
        this.props.handleChange(this.state.checkedItems, this.props.field);
      })
    } else {
      let checkedItems = [...this.state.checkedItems, ...items]
      this.setState({
        checkedItems: [...new Set(checkedItems)]
      }, () => {
        this.props.handleChange(this.state.checkedItems, this.props.field);
      })
    }
  }
  checkIfGroupChecked = (group) => {
    const items = this.props.groupBy[group];
    let selected_items = items.filter(item => this.state.checkedItems.includes(item))
    return selected_items.length > 0;
  }
  componentWillReceiveProps(nextProps) {
    if(this.props.query !== nextProps.query){
      this.setState({checkedItems: []});
    }
  }
  renderItem = (item) => {
    return (
      <ListGroupItem key={item} className="text-left border-0 py-1" style={this.props.liStyle}>
        <Checkbox name={item} checked={ this.state.checkedItems.includes(item) } handleChange={this.toggleItem}/>
      </ListGroupItem>
    )
  }
  renderList = () => {
    const items = this.props.items.filter((item) => item !== '').sort();
    const groups = this.props.groupBy;

    if(groups){
      return Object.keys(groups).sort().map(group =>
        <React.Fragment key={group}>
          <ListGroupItem key={group} className="text-left border-0 pb-1 pt-3 groupCheckbox">
            <Checkbox name={group} checked={ this.checkIfGroupChecked(group) } handleChange={this.toggleGroup}/>
          </ListGroupItem>
          <div className="pl-4">
            { groups[group].sort().map(typ => this.renderItem(typ)) }
          </div>
        </React.Fragment>
      )
    } else {
      return items.map(typ => this.renderItem(typ))
    }
  }
  render(){
    return (
      this.props.items.length > 0 &&
      <React.Fragment>
        <ListGroupItem className="text-left d-flex justify-content-between border-0 action paul-filter-toggle" onClick={() => this.setState({collapse: !this.state.collapse})}>
          <h6>{ this.props.name }</h6><i className={this.state.collapse ? 'fas fa-chevron-up' : 'fas fa-chevron-down'}></i>
        </ListGroupItem>
        <Collapse isOpen={this.state.collapse}>
          { this.renderList() }
          <ListGroupItem className="text-left border-0 py-2"></ListGroupItem>
        </Collapse>
      </React.Fragment>
    )
  }
}

export class RangeFilter extends Component {
  constructor(props){
    super(props);
    this.state = {
      value: {
        min: Math.min(...Object.keys(this.props.items)),
        max: Math.max(...Object.keys(this.props.items))
      },
      range: {
        min: Math.min(...Object.keys(this.props.items)),
        max: Math.max(...Object.keys(this.props.items))
      }
    }
  }
  handleChange = () => {
    if(
      this.state.value.min !== this.state.range.min ||
      this.state.value.max !== this.state.range.max
    ) {
      this.props.handleChange({
        min: this.state.value.min,
        max: this.state.value.max
      },this.props.field);
    } else {
      this.props.handleChange(false, this.props.field);
    }
  }
  componentWillReceiveProps(nextProps) {
    const old_min = Math.min(...Object.keys(this.props.items));
    const old_max = Math.max(...Object.keys(this.props.items));
    const new_min = Math.min(...Object.keys(nextProps.items));
    const new_max = Math.max(...Object.keys(nextProps.items));

    if(old_min !== new_min || old_max !== new_max){
      this.setState({
        value: {
          min: new_min,
          max: new_max
        },
        range: {
          min: new_min,
          max: new_max
        }
      });
    }
  }
  render(){
    if(this.state.range.max-this.state.range.min > 1){
      return (
        <React.Fragment>
          <ListGroupItem className="text-left d-flex justify-content-between border-0 filterHeadline">
            <h6>{this.props.name}</h6>
          </ListGroupItem>
          <ListGroupItem className="text-left border-0 pt-0 pb-4">
            <h6 className="text-secondary mb-2">{this.state.value.min}–{this.state.value.max}</h6>
            <ClusterWave {...this.props} />
            <InputRange
              maxValue={this.state.range.max}
              minValue={this.state.range.min}
              value={this.state.value}
              onChange={value => this.setState({ value: value })}
              onChangeComplete={this.handleChange}
              className="paul-filter-range"
            />
          </ListGroupItem>
        </React.Fragment>
      );
    } else {
      return <React.Fragment></React.Fragment>;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ui-elements/Filter.js